@if (
  canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Control) &&
  isControlType(controllableObjectData()?.data.type)
) {
  <div
    class="section section--control"
    [attr.data-cy]="'navigation-controllable-object-' + controllableObjectData().data.objectId"
  >
    @if (
      canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Label) &&
      (controllableObjectData().data.label | cmLocalizedString)
    ) {
      <h2 class="title">{{ controllableObjectData().data.label | cmLocalizedString }}</h2>
    }

    @if (canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Control)) {
      @if (
        (controllableObjectData().data.message.text | cmLocalizedString) &&
        controllableObjectData().data.message.type != messageTypeEnum.Nothing
      ) {
        <div class="message {{ controllableObjectData().data.message.type }}">
          @if (controllableObjectData().data.message.iconUrl || controllableObjectData().data.message.type) {
            <cue-icon
              [icon]="
                controllableObjectData().data.message.iconUrl ??
                getDefaultIconAccordingStatus(controllableObjectData().data.message.type)
              "
              [customIconClass]="'message-icon'"
            />
          }
          {{ controllableObjectData().data.message.text | cmLocalizedString }}
        </div>
      }

      <div class="content">
        @for (groupItem of controllableObjectData().data.group; track groupItem) {
          <div class="group">
            <!--      GROUPA PRO OVLADACI PRVKY-->
            @if (groupItem.label) {
              <h3 class="group-title">{{ groupItem.label | cmLocalizedString }}</h3>
            }
            @if ((groupItem.message.text | cmLocalizedString) && groupItem.message.type != messageTypeEnum.Nothing) {
              <div class="message {{ groupItem.message.type }}">
                @if (groupItem.message.iconUrl || groupItem.message.type) {
                  <cue-icon
                    [icon]="groupItem.message.iconUrl ?? getDefaultIconAccordingStatus(groupItem.message?.type)"
                    [customIconClass]="'message-icon'"
                  />
                }

                {{ groupItem.message.text | cmLocalizedString }}
              </div>
            }
            <!--      JEDNOTLIVE PRVKY-->
            <div class="group-items">
              @for (item of groupItem.item; track item) {
                @if (item.type === 'pushButton') {
                  <button
                    type="button"
                    cue-button
                    variant="control"
                    [disabled]="item.state !== 'enabled'"
                    class="{{ item.indication }} push-button"
                    [class.with-icon]="item.iconUrl"
                    [class.icon-only]="!item.label && !item.value && !item.unit"
                    (click)="performAction(item)"
                  >
                    @if (item.iconUrl) {
                      <cue-icon [icon]="item.iconUrl" [customIconClass]="'icon'" />
                    }
                    @if (item.label || item.value || item.unit) {
                      <span class="label-and-value">
                        @if (item.label) {
                          <span class="label" [class.label-only]="!(item.value || item.unit)">{{
                            item.label | cmLocalizedString
                          }}</span>
                        }
                        @if (item.value || item.unit) {
                          <span class="value-and-unit">
                            @if (item.value) {
                              <span class="value">{{ item.value | cmLocalizedString }} </span>
                            }
                            @if (item.unit) {
                              <span class="unit">{{ item.unit | cmLocalizedString }}</span>
                            }
                          </span>
                        }
                      </span>
                    }
                  </button>
                }
                @if (item.type === 'hidden') {
                  <div class="hidden-btn"></div>
                  <!--                                    <button-->
                  <!--                                        cue-button-->
                  <!--                                        variant="control"-->
                  <!--                                        [disabled]="item.state !== 'enabled'"-->
                  <!--                                        class="{{ item.indication }} push-button"-->
                  <!--                                        [class.with-icon]="item.iconUrl"-->
                  <!--                                        [class.icon-only]="!item.label && !item.value && !item.unit"-->
                  <!--                                        (click)="performAction(item)"-->
                  <!--                                    >-->
                  <!--                                    </button>-->
                } @else if (item.type === 'repeatButton') {
                  <button
                    type="button"
                    (mouseleave)="repeatButtonEnd(item)"
                    (mousedown)="repeatButtonStart(item)"
                    (mouseup)="repeatButtonEnd(item)"
                    cue-button
                    variant="control"
                    [disabled]="item.state !== 'enabled'"
                    class="{{ item.indication }} repeat-button"
                    [class.with-icon]="item.iconUrl"
                  >
                    @if (item.iconUrl) {
                      <cue-icon [icon]="item.iconUrl" [customIconClass]="'icon'" />
                    }
                    @if (item.label || item.value || item.unit) {
                      <span class="label-and-value">
                        @if (item.label) {
                          <span class="label" [class.label-only]="!(item.value || item.unit)">{{
                            item.label | cmLocalizedString
                          }}</span>
                        }
                        @if (item.value || item.unit) {
                          <span class="value-and-unit">
                            @if (item.value) {
                              <span class="value">{{ item.value | cmLocalizedString }} </span>
                            }
                            @if (item.unit) {
                              <span class="unit">{{ item.unit | cmLocalizedString }}</span>
                            }
                          </span>
                        }
                      </span>
                    }
                  </button>
                } @else if (item.type === 'value') {
                  <div class="value-type">
                    @if (item.label) {
                      <span class="label">{{ item.label | cmLocalizedString }}</span>
                    }
                    <span class="value">
                      @if (item.value) {
                        <span>{{ item.value | cmLocalizedString }}</span>
                      }
                      @if (item.unit) {
                        <span>{{ item.unit | cmLocalizedString }}</span>
                      }
                    </span>
                  </div>
                }
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
}
@if (isValueInputType(controllableObjectData()?.data.type) && canShowValueInput(controllableObjectData())) {
  <div
    class="section section--value-input"
    [attr.data-cy]="'navigation-controllable-object-' + controllableObjectData().data.objectId"
  >
    @if (canShowValueInputObjectLabel(controllableObjectData())) {
      <h2 class="title">{{ controllableObjectData().data.label | cmLocalizedString }}</h2>
    }

    <div class="content">
      @for (item of controllableObjectData().data.item ?? []; track item.id) {
        @if (hasValueInputContent(item)) {
          <div
            class="value-input-item"
            [class.value-input-item--with-arrows]="isNumberInputType(controllableObjectData().data.type)"
          >
            <div class="value-input-item__main">
              @if (
                (canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Label) &&
                  item.label) ||
                (isNumberInputType(controllableObjectData().data.type) &&
                  canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Limits) &&
                  hasInputLimits(item))
              ) {
                <div class="value-input-item__label-row">
                  @if (
                    canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Label) && item.label
                  ) {
                    <span
                      class="value-input-item__label"
                      [attr.data-cy]="
                        'navigation-controllable-item-label-' + controllableObjectData().data.objectId + '-' + item.id
                      "
                      >{{ item.label | cmLocalizedString }}</span
                    >
                  }
                  @if (
                    isNumberInputType(controllableObjectData().data.type) &&
                    canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Limits) &&
                    hasInputLimits(item)
                  ) {
                    @let allowedValueRange =
                      'monitorAndControl.allowedValueRange' | transloco: { range: getInputLimitsText(item) };
                    <button
                      type="button"
                      class="value-input-item__limits-tooltip-button"
                      [attr.aria-label]="allowedValueRange"
                      [cueTooltip]="allowedValueRange"
                      cueTooltipCommonType="info"
                      [cueTooltiptOptions]="{ trigger: 'click' }"
                      [cueTooltipHasBackdrop]="true"
                      cueTooltipBackdropClass="cdk-overlay-transparent-backdrop"
                      (click)="stopEditableInputEvent($event)"
                    >
                      <cue-icon [icon]="ICONS.cueInfo" />
                    </button>
                  }
                </div>
              }

              <div
                class="value-input-item__value-row"
                [class.value-input-item__value-row--with-number-error]="hasNumberInputRangeError(item.id)"
                [class.value-input-item__value-row--with-limits-tooltip]="
                  isNumberInputType(controllableObjectData().data.type) &&
                  canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Limits) &&
                  hasInputLimits(item)
                "
              >
                @if (
                  isSliderType(controllableObjectData().data.type) &&
                  canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Control)
                ) {
                  <div class="value-input-item__slider-row">
                    <button
                      type="button"
                      variant="outlined"
                      cue-button
                      class="value-input-item__slider-button value-input-item__slider-button--decrease icon-only square"
                      [attr.data-cy]="
                        'navigation-controllable-slider-min-step-' +
                        controllableObjectData().data.objectId +
                        '-' +
                        item.id
                      "
                      [disabled]="isSliderAtMin(item)"
                      cueRepeatPress
                      (cueRepeatPress)="stepSliderValue(item, getSliderMinStepDirection(item))"
                    >
                      <cue-icon [icon]="ICONS.cueMinus" [customIconClass]="'icon'" />
                    </button>
                    <kendo-slider
                      [cueSliderDirection]="isSliderReversed(item) ? 'rtl' : 'ltr'"
                      class="value-input-item__slider"
                      [attr.data-cy]="
                        'navigation-controllable-slider-' + controllableObjectData().data.objectId + '-' + item.id
                      "
                      [min]="getSliderLowerBound(item)"
                      [max]="getSliderUpperBound(item)"
                      [smallStep]="getSliderStep(item)"
                      [showButtons]="false"
                      [ngModel]="getSliderValue(item)"
                      [ngModelOptions]="{ standalone: true }"
                      (click)="stopEditableInputEvent($event)"
                      (valueChange)="onSliderValueChanged(item.id, $event)"
                    ></kendo-slider>
                    <button
                      type="button"
                      variant="outlined"
                      cue-button
                      class="value-input-item__slider-button value-input-item__slider-button--increase icon-only square"
                      [attr.data-cy]="
                        'navigation-controllable-slider-max-step-' +
                        controllableObjectData().data.objectId +
                        '-' +
                        item.id
                      "
                      [disabled]="isSliderAtMax(item)"
                      cueRepeatPress
                      (cueRepeatPress)="stepSliderValue(item, getSliderMaxStepDirection(item))"
                    >
                      <cue-icon [icon]="ICONS.cuePlus" [customIconClass]="'icon'" />
                    </button>
                  </div>
                } @else if (
                  isTimeInputType(controllableObjectData().data.type) &&
                  canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Control)
                ) {
                  <assist-timepicker
                    class="value-input-item__time-picker"
                    [attr.data-cy]="
                      'navigation-controllable-time-' + controllableObjectData().data.objectId + '-' + item.id
                    "
                    [format]="'HH:mm'"
                    [steps]="{ hour: 1, minute: 1 }"
                    [value]="getTimePickerValue(item)"
                    enterKeyBehavior="blur"
                    (click)="stopEditableInputEvent($event)"
                    (valueCommit)="commitTimePickerValue(item.id, $event)"
                  />
                } @else if (
                  isNumberInputType(controllableObjectData().data.type) &&
                  canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Control)
                ) {
                  <kendo-numerictextbox
                    #longNumberInput="kendoNumericTextBox"
                    cueNumericSpinnerChange
                    class="value-input-item__number-input"
                    [attr.data-cy]="
                      'navigation-controllable-number-' + controllableObjectData().data.objectId + '-' + item.id
                    "
                    [class.k-invalid]="hasNumberInputRangeError(item.id)"
                    [format]="
                      isDoubleNumberInputType(controllableObjectData().data.type) ? '0.####################' : 'n0'
                    "
                    [autoCorrect]="false"
                    [min]="item.minimum"
                    [max]="item.maximum"
                    [step]="item.step ?? 1"
                    [value]="getInputValue(item)"
                    [attr.aria-invalid]="hasNumberInputRangeError(item.id) ? 'true' : null"
                    (click)="stopEditableInputEvent($event)"
                    (cueNumericSpinnerChange)="commitNumberValue(item, $event, controllableObjectData().data.type)"
                    (blur)="commitNumberValue(item, longNumberInput.value, controllableObjectData().data.type)"
                    (keydown.enter)="commitNumberValue(item, longNumberInput.value, controllableObjectData().data.type)"
                  ></kendo-numerictextbox>
                  @if (hasNumberInputRangeError(item.id)) {
                    <span
                      class="value-input-item__number-error"
                      aria-live="polite"
                      [attr.data-cy]="
                        'navigation-controllable-number-error-' + controllableObjectData().data.objectId + '-' + item.id
                      "
                    >
                      {{ 'monitorAndControl.valueOutsideAllowedRange' | transloco }}
                    </span>
                  }
                }

                @if (
                  !isSliderType(controllableObjectData().data.type) &&
                  ((!isValueInputType(controllableObjectData().data.type) &&
                    canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Value) &&
                    hasInputValue(item)) ||
                    (!isTimeInputType(controllableObjectData().data.type) &&
                      canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Unit) &&
                      item.unit))
                ) {
                  <div class="value-input-item-text">
                    @if (
                      !isValueInputType(controllableObjectData().data.type) &&
                      canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Value) &&
                      hasInputValue(item)
                    ) {
                      <span class="value-input-item__value">{{ getInputValue(item) }}</span>
                    }

                    @if (
                      !isTimeInputType(controllableObjectData().data.type) &&
                      canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Unit) &&
                      item.unit
                    ) {
                      <span class="value-input-item__unit">{{ item.unit | cmLocalizedString }}</span>
                    }
                  </div>
                }
              </div>

              @if (isSliderType(controllableObjectData().data.type)) {
                <div class="value-input-item__slider-footer">
                  @if (
                    canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Limits) &&
                    hasInputLimits(item)
                  ) {
                    <button
                      type="button"
                      class="value-input-item__slider-limit value-input-item__slider-limit--min"
                      [disabled]="isSliderAtMin(item)"
                      (click)="stopEditableInputEvent($event); setSliderToMin(item)"
                    >
                      {{ getSliderMin(item) }}
                    </button>
                  } @else {
                    <span class="value-input-item__slider-limit-spacer"></span>
                  }

                  @if (
                    (canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Control) &&
                      hasInputValue(item)) ||
                    (canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Unit) && item.unit)
                  ) {
                    <span
                      class="value-input-item__slider-current"
                      [attr.data-cy]="
                        'navigation-controllable-slider-current-' +
                        controllableObjectData().data.objectId +
                        '-' +
                        item.id
                      "
                    >
                      @if (
                        canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Control) &&
                        hasInputValue(item)
                      ) {
                        <span class="value-input-item__value">{{ getInputValue(item) }}</span>
                      }
                      @if (
                        canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Unit) &&
                        item.unit
                      ) {
                        <span class="value-input-item__unit">{{ item.unit | cmLocalizedString }}</span>
                      }
                    </span>
                  } @else {
                    <span class="value-input-item__slider-current"></span>
                  }

                  @if (
                    canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Limits) &&
                    hasInputLimits(item)
                  ) {
                    <button
                      type="button"
                      class="value-input-item__slider-limit value-input-item__slider-limit--max"
                      [disabled]="isSliderAtMax(item)"
                      (click)="stopEditableInputEvent($event); setSliderToMax(item)"
                    >
                      {{ getSliderMax(item) }}
                    </button>
                  } @else {
                    <span class="value-input-item__slider-limit-spacer"></span>
                  }
                </div>
              }
            </div>
          </div>
        }
      }
    </div>
  </div>
}
@if (isMonitorType(controllableObjectData()?.data.type)) {
  <div
    class="section section--monitor"
    [attr.data-cy]="'navigation-controllable-object-' + controllableObjectData().data.objectId"
  >
    @if (canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.ObjectLabel)) {
      <h2 class="title">{{ controllableObjectData().data.label | cmLocalizedString }}</h2>
    }
    <!--      JEDNOTLIVE PRVKY-->
    <div class="content">
      @for (item of controllableObjectData().data.item; track item) {
        @if (item.iconUrl || item.value || item.label) {
          <div
            class="item"
            [ngStyle]="{
              'background-color': canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Color)
                ? controllableObjectData().data.color
                : 'none',
              color: getTextColorIfAvailable(controllableObjectData()),
            }"
            [class.has-color]="
              canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Color) && item.color
            "
          >
            <div class="item__icon-wrapper">
              @if (
                canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Icon) && item.iconUrl
              ) {
                <cue-icon
                  [icon]="item.iconUrl"
                  [customIconClass]="'item__icon'"
                  [ngStyle]="{
                    'background-color':
                      canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Color) &&
                      item.color
                        ? item.color
                        : 'none',
                    '--automatic-icon-color': getTextColorBasedOnBg(item.color),
                  }"
                />
              } @else if (
                canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Color) && item.color
              ) {
                <span
                  class="color-icon"
                  [ngStyle]="{
                    'background-color': item.color,
                  }"
                ></span>
              }
            </div>
            @if (canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Value) && item.value) {
              <span class="item__value">{{ item.value | cmLocalizedString }}</span>
            }
            @if (canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Unit) && item.unit) {
              <span class="item__unit">{{ item.unit | cmLocalizedString }}</span>
            }
            @if (canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Label) && item.label) {
              <span class="item__label">{{ item.label | cmLocalizedString }}</span>
            }
          </div>
        }
      }
    </div>
  </div>
}
@if (
  isIndicatorType(controllableObjectData()?.data.type) &&
  (canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Color) ||
    canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Value) ||
    canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Label))
) {
  <div
    class="section section--indicator"
    [attr.data-cy]="'navigation-controllable-object-' + controllableObjectData().data.objectId"
  >
    <!--      JEDNOTLIVE PRVKY-->
    <div class="content">
      <div
        class="item"
        [class.has-value]="
          canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Value) &&
            controllableObjectData().data.value | cmLocalizedString
        "
        [class.has-icon]="
          canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Icon) &&
          controllableObjectData().data.iconUrl
        "
        [class.has-label]="
          canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Label) &&
          controllableObjectData().data.label
        "
        [class.has-color]="
          canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Color) &&
          controllableObjectData().data.color
        "
        [ngStyle]="{
          'background-color': canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Color)
            ? controllableObjectData().data.color
            : 'none',
          color: getTextColorIfAvailable(controllableObjectData()),
        }"
      >
        @if (
          canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Icon) &&
          controllableObjectData().data.iconUrl &&
          (!(
            canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Label) &&
            controllableObjectData().data.label
          ) ||
            (canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Label) &&
              controllableObjectData().data.label &&
              !(
                canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Value) &&
                controllableObjectData().data.value
              )))
        ) {
          <cue-icon [icon]="controllableObjectData().data.iconUrl" [customIconClass]="'icon'" />
        }
        @if (canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Value)) {
          <span class="item__value">{{ controllableObjectData().data.value | cmLocalizedString }}</span>
        }
      </div>

      @if (
        canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Label) &&
        controllableObjectData().data.label
      ) {
        @if (
          canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Icon) &&
          controllableObjectData().data.iconUrl &&
          canShowHideableItemProperty(controllableObjectData(), showInMapOrDetailModeEnum.Value) &&
          controllableObjectData().data.value
        ) {
          <cue-icon [icon]="controllableObjectData().data.iconUrl" [customIconClass]="'icon'" />
        }
        <span class="label">{{ controllableObjectData().data.label | cmLocalizedString }}</span>
      }
    </div>
  </div>
}
